import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, ParamMap, Params, Router} from '@angular/router';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {GeneralService} from '../../services/general.service';
import {Response, StaticMethods} from '../../model/GeneralModels';

@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['../../assets/css/light.theme.css'],
  styles: [`
    .card-2 .card-heading-health-family {
      background: none !important;
      width: 0 !important;
    }

    h5 {
      line-height: 25px;
    }

    .custom {
      white-space: normal !important;
      text-align: justify;
    }
  `]
})
export class NotesComponent implements OnInit {
  formGroup: FormGroup;
  notes: string;
  requestID: number;
  appUrl: string;
  productName: string;

  constructor(private router: Router, private fb: FormBuilder, private generalService: GeneralService,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
      console.log(this.appUrl, this.requestID, params);
      this.requestID = parseInt(params.requestID, 10);
      this.productName = params.productName;
      console.log(this.productName);
      this.appUrl = StaticMethods.getBaseUrl(this.productName);
      this.generalService.getNotes(this.requestID, this.productName).subscribe((response: Response) => {
        if (response.success) {
          if (response.data) {
            this.notes = response.data;
          } else {
            this.next();
          }
        }
      });
    });
    this.formGroup = this.fb.group({
      accept: ['', Validators.required]
    });
  }

  next() {
    this.router.navigate([`/${this.productName}/forms`], {state: history.state});
  }
}
